import get from "lodash.get";

import { CurrenciesEnum, MINIMAL_DONATION_AMOUNT } from "../enums/currencies";
import { FeeElementModel } from "../models/models";

export default class CurrencyHelper {
  static getMinimalDonationSum = (donationSum: number, currency: string) => {
    const currenciesList = Object.keys(CurrenciesEnum);
    if (
      currenciesList.indexOf(currency) !== -1 &&
      donationSum < MINIMAL_DONATION_AMOUNT
    ) {
      return MINIMAL_DONATION_AMOUNT;
    }

    return donationSum;
  };

  static getNumberValue = (value: number) => {
    if (typeof value === "number") {
      return value.toFixed(2);
    }
    return "";
  };

  static getRowNumberValue = (value: number, allowZero: any) => {
    if (value || (allowZero && value === 0)) {
      if (typeof value === "number") {
        return value >= 0 ? `$${value.toFixed(2)}` : `-$${(-value).toFixed(2)}`;
      }
      return value;
    }
    return "";
  };

  static getTicketingTaxValue = (paymentFees: FeeElementModel) => {
    const isTaxIncluded = get(paymentFees, "taxIsIncluded");
    const saleTaxValue = get(paymentFees, "tax");
    return isTaxIncluded ? saleTaxValue : 0;
  };

  static formatDecimalNumber = (number: number, thousandSeparator = false) => {
    const fractionsToUse = Number.isInteger(number) ? 0 : 2;
    const fixedNumber = number.toFixed(fractionsToUse);
    return thousandSeparator
      ? CurrencyHelper.numberWithCommas(fixedNumber)
      : fixedNumber;
  };

  static formatCurrencyNumber = (number: number) => {
    const fixedNumber = number.toFixed(2);
    return CurrencyHelper.numberWithCommas(fixedNumber);
  };

  static numberWithCommas = (number: { toString: () => string }) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  static parseFloat = (number: string) => {
    if (number) {
      return Number.parseFloat(number);
    }
    return null;
  };
}
